import { Component, Input } from '@angular/core';
import { OrganisationPreferenceDto } from '@careapp-group/ng-sdk';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Memos } from '../../store';
import * as selectors from '../../store/reducers/index';

/*
 ** A wrapper for images to provide a download button for that image.
 ** The download button will only be displayed if an element of the user's current
 ** roles is within the org preferences 'saveImageRoles' array.
 */

@Component({
  selector: 'ca-image-download-button',
  templateUrl: './image-download-button.component.html',
  styleUrls: ['./image-download-button.component.scss'],
  standalone: false,
})
export class ImageDownloadButtonComponent {
  @Input() url: string;
  @Input() memoID: string;
  @Input() fileID: string;

  markAsDownloaded(event: Event) {
    event.stopPropagation();

    if (!this.memoID) {
      return;
    }

    this.store.dispatch(
      Memos.requestLogSavedFileAction({ fileId: this.fileID, memoId: this.memoID }),
    );
  }

  // Organisation preferences
  orgPreferences$: Observable<any>;
  preferencesData: OrganisationPreferenceDto;
  orgPreferencesSubscription: Subscription;
  orgSaveImageRoles: string[] = [];

  constructor(public store: Store<any>) {
    this.orgPreferences$ = this.store.select(selectors.org.currentOrgPreferences);

    this.orgPreferencesSubscription = this.orgPreferences$.subscribe((preferences) => {
      this.preferencesData = <any>{
        ...(preferences || {}),
      };
      this.orgSaveImageRoles = this.preferencesData?.saveImageRoles ?? [];
    });
  }

  ngOnDestroy() {
    this.orgPreferencesSubscription.unsubscribe();
  }
}
